import { OBaseModel } from '@olameter/o-utilities';

export class InventoryBase implements OBaseModel {
  name: string;
  FsrIdentifier: string;
  AssignedTo: string;
  StatusWeb: string;
  ServiceType: string;
  Audited: boolean;
  AuditorName: string;
  InventoryType: string;
}
